// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Brand / Semantic */
  --color-primary: #003b5c;
  --color-success: #24925c;
  --color-danger: #dc4405;
  --color-warning: #ffb549;
  --color-info: #3eafe0;
  --color-error: #b40000;
  --color-neutral: #8a8c8e;

  /* Layout */
  --color-background: #e7e7e7;
  --color-surface: #ffffff;
  --color-foreground: #f5f5f5;
  --color-divider: #e7e7e7;
  --color-text-primary: #000000;
  --color-text-secondary: #8a8c8e;

  /* Status Badges */
  --color-status-available-bg: #e6f4ed;
  --color-status-available-text: #24925c;
  --color-status-busy-bg: #fff5e0;
  --color-status-busy-text: #b8860b;
  --color-status-offline-bg: #fde8e0;
  --color-status-offline-text: #dc4405;
  --color-status-claimed-bg: #e0edf7;
  --color-status-claimed-text: #1a6fb5;
  --color-status-installing-bg: #fff5e0;
  --color-status-installing-text: #b8860b;
  --color-status-ready-bg: #e0f5f5;
  --color-status-ready-text: #0e7c7b;

  /* Typography */
  --font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;
  --font-mono: 'SF Mono', 'Fira Code', monospace;
  --font-size-xs: 11px;
  --font-size-sm: 12px;
  --font-size-base: 13px;
  --font-size-md: 14px;
  --font-size-lg: 16px;
  --font-size-xl: 18px;
  --font-size-stat: 28px;

  /* Spacing */
  --space-xs: 4px;
  --space-sm: 8px;
  --space-md: 12px;
  --space-lg: 16px;
  --space-xl: 24px;

  /* Borders & Shadows */
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-pill: 10px;
  --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.08);
  --border-default: 1px solid #e7e7e7;

  /* Layout */
  --sidebar-width: 220px;
  --device-card-min-width: 200px;
  --touch-target-min: 44px;
  --breakpoint-tablet: 768px;
  --breakpoint-desktop: 1280px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-family);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background: var(--color-background);
  min-height: 100vh;
}

h1, h2, h3 {
  color: var(--color-primary);
}

a {
  color: var(--color-info);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

button {
  font-family: var(--font-family);
  cursor: pointer;
}

input, select {
  font-family: var(--font-family);
  font-size: var(--font-size-base);
}
`, "",{"version":3,"sources":["webpack://./dashboard/src/styles/tokens.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;;EAExB,WAAW;EACX,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;;EAE/B,kBAAkB;EAClB,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;EAC/B,iCAAiC;EACjC,kCAAkC;EAClC,oCAAoC;EACpC,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;EAChC,kCAAkC;;EAElC,eAAe;EACf,0FAA0F;EAC1F,8CAA8C;EAC9C,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;;EAEtB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,mCAAmC;;EAEnC,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC","sourcesContent":[":root {\n  /* Brand / Semantic */\n  --color-primary: #003b5c;\n  --color-success: #24925c;\n  --color-danger: #dc4405;\n  --color-warning: #ffb549;\n  --color-info: #3eafe0;\n  --color-error: #b40000;\n  --color-neutral: #8a8c8e;\n\n  /* Layout */\n  --color-background: #e7e7e7;\n  --color-surface: #ffffff;\n  --color-foreground: #f5f5f5;\n  --color-divider: #e7e7e7;\n  --color-text-primary: #000000;\n  --color-text-secondary: #8a8c8e;\n\n  /* Status Badges */\n  --color-status-available-bg: #e6f4ed;\n  --color-status-available-text: #24925c;\n  --color-status-busy-bg: #fff5e0;\n  --color-status-busy-text: #b8860b;\n  --color-status-offline-bg: #fde8e0;\n  --color-status-offline-text: #dc4405;\n  --color-status-claimed-bg: #e0edf7;\n  --color-status-claimed-text: #1a6fb5;\n  --color-status-installing-bg: #fff5e0;\n  --color-status-installing-text: #b8860b;\n  --color-status-ready-bg: #e0f5f5;\n  --color-status-ready-text: #0e7c7b;\n\n  /* Typography */\n  --font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif;\n  --font-mono: 'SF Mono', 'Fira Code', monospace;\n  --font-size-xs: 11px;\n  --font-size-sm: 12px;\n  --font-size-base: 13px;\n  --font-size-md: 14px;\n  --font-size-lg: 16px;\n  --font-size-xl: 18px;\n  --font-size-stat: 28px;\n\n  /* Spacing */\n  --space-xs: 4px;\n  --space-sm: 8px;\n  --space-md: 12px;\n  --space-lg: 16px;\n  --space-xl: 24px;\n\n  /* Borders & Shadows */\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-pill: 10px;\n  --shadow-card: 0 1px 3px rgba(0, 0, 0, 0.08);\n  --border-default: 1px solid #e7e7e7;\n\n  /* Layout */\n  --sidebar-width: 220px;\n  --device-card-min-width: 200px;\n  --touch-target-min: 44px;\n  --breakpoint-tablet: 768px;\n  --breakpoint-desktop: 1280px;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-family);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background: var(--color-background);\n  min-height: 100vh;\n}\n\nh1, h2, h3 {\n  color: var(--color-primary);\n}\n\na {\n  color: var(--color-info);\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\nbutton {\n  font-family: var(--font-family);\n  cursor: pointer;\n}\n\ninput, select {\n  font-family: var(--font-family);\n  font-size: var(--font-size-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
